import { render, staticRenderFns } from "./Select.vue?vue&type=template&id=0fbf8872&scoped=true"
import script from "./Select.vue?vue&type=script&lang=js"
export * from "./Select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbf8872",
  null
  
)

export default component.exports